import calendarIcon from '../../assets/icons/calendar.png';
import wheelIcon from '../../assets/icons/wheel.png';
import crystalBallIcon from '../../assets/icons/crystal_ball.png';
import megaphoneIcon from '../../assets/icons/megaphone.png';
import { useNavigate } from 'react-router';

const PLAYGROUND_SCROLL_KEY = 'playground-scroll-top';

const quickRewardItems = [
  {
    id: 'attendance',
    icon: calendarIcon,
    title: '야옹출석',
    point: 300,
    pointColorClass: 'text-primary-purple-01',
    path: '/attendance-check',
  },
  {
    id: 'lucky-spin',
    icon: wheelIcon,
    title: '럭키스핀',
    point: 600,
    pointColorClass: 'text-primary-purple-01',
    path: '/cat-lucky-spin',
  },
  {
    id: 'quiz-fortune',
    icon: crystalBallIcon,
    title: '퀴즈/운세',
    point: '1,000',
    pointColorClass: 'text-primary-purple-01',
    path: '/random-luck',
  },
  {
    id: 'invite-friends',
    icon: megaphoneIcon,
    title: '친구소환',
    point: '1,000',
    pointColorClass: 'text-primary-purple-01',
    path: '/invite',
  },
];

function PlaygroundQuickRewardRow() {
  const navigate = useNavigate();

  const saveAndNavigate = (item) => {
    if (item.id === 'quiz-fortune') {
      window.flutter_inappwebview?.callHandler?.('goto_offerwall_content');
      return;
    }

    const pageContainer = document.getElementsByClassName('page-container')[0];
    if (pageContainer) {
      const top = Math.max(pageContainer.scrollTop ?? 0, window.scrollY || 0);
      sessionStorage.setItem(PLAYGROUND_SCROLL_KEY, String(top));
    }
    navigate(item.path);
  };

  return (
    <div className="px-2">
      <div className="flex w-full items-start gap-2">
        {quickRewardItems.map((item) => (
          <article
            key={item.id}
            className="flex h-28 flex-1 cursor-pointer flex-col items-center rounded-xl bg-white px-1 py-2 shadow-[0px_6px_16px_0px_rgba(0,0,0,0.08)]"
            onClick={() => saveAndNavigate(item)}
          >
            <div className="flex h-11 w-11 items-center justify-center">
              <img src={item.icon} alt={item.title} className="h-[34px] w-[34px] object-contain" />
            </div>
            <div className="mt-2 text-center text-sm text-gray05 font-['Pretendard'] font-bold">{item.title}</div>
            <div className="mt-1 inline-flex items-start justify-center rounded-[5px] bg-background01 px-1.5 py-[3px]">
              <span className={`text-center text-[10px] font-bold font-['Pretendard'] ${item.pointColorClass}`}>
                최대 {item.point.toLocaleString()}P
              </span>
            </div>
          </article>
        ))}
      </div>
    </div>
  );
}

export default PlaygroundQuickRewardRow;
